import * as types from './types'
import actions from './actions'
import getters from './getters.js'
import Vue from 'vue'

const state = {
  checkedOnPage: {},
  actualListPage: 0,
  selectedResource: null,
  selectedResourceSecondLevel: null,
  lastUrl: null,
  resourceOverviewList: null,
  secondResourceOverviewList: null,
  totalNumberOverviewList: 0,
  isFetchingList: false
}

const mutations = {
  [types.SELECT_RESOURCE] (state, action) {
    if (state.selectedResource !== null && state.selectedResource.id === action.resource.id) {
      state.selectedResource = null
    } else {
      state.selectedResource = action.resource
    }
  },
  [types.UPDATE_SELECTED_RESOURCE] (state, action) {
    state.selectedResource = { ...state.selectedResource, ...action.resource }
  },
  [types.SELECT_RESOURCE_SECOND] (state, action) {
    if (action === null) {
      state.selectedResourceSecondLevel = null
    } else if (state.selectedResourceSecondLevel !== null && state.selectedResourceSecondLevel.id === action.resource.id) {
      state.selectedResourceSecondLevel = null
    } else {
      state.selectedResourceSecondLevel = action.resource
    }
  },
  [types.UPDATE_SELECTED_RESOURCE_SECOND] (state, action) {
    state.selectedResourceSecondLevel = { ...state.selectedResourceSecondLevel, ...action.resource }
  },
  [types.TOGGLE_CHECK_ALL] (state, action) {
    if (state.checkedOnPage[action.page] !== undefined && Object.keys(state.checkedOnPage[action.page]).length > 0) {
      Vue.set(state.checkedOnPage, action.page, {})
    } else {
      if (state.checkedOnPage[action.page] === undefined) {
        Vue.set(state.checkedOnPage, action.page, {})
      }
      action.hitsOnPage.forEach(el => {
        Vue.set(state.checkedOnPage[action.page], el.id, el)
      })
    }
  },
  [types.TOGGLE_CHECK_RESOURCE] (state, action) {
    if (state.checkedOnPage[action.page] === undefined) {
      Vue.set(state.checkedOnPage, action.page, {})
    }
    if (state.checkedOnPage[action.page][action.resource.id] !== undefined) {
      Vue.delete(state.checkedOnPage[action.page], action.resource.id)
    } else {
      Vue.set(state.checkedOnPage[action.page], action.resource.id, action.resource)
    }
  },
  [types.CHANGE_LIST_PAGE] (state, page) {
    state.actualListPage = page
  },
  [types.CLEAR_RESOURCES_STORE] (state) {
    state.checkedOnPage = {}
    state.actualListPage = 0
    state.selectedResource = null
  },
  [types.SET_CONTENT_LAST_URL] (state, action) {
    state.lastUrl = action.url
  },
  [types.SET_RESOURCE_LIST] (state, action) {
    state.resourceOverviewList = action.items
  },
  [types.ADD_RESOURCE_LIST_ITEM] (state, action) {
    state.resourceOverviewList = [].concat([action.item], state.resourceOverviewList)
    state.totalNumberOverviewList = state.resourceOverviewList.length
  },
  [types.SET_SECOND_RESOURCE_LIST] (state, action) {
    state.secondResourceOverviewList = action.items
  },
  [types.UPDATE_SECOND_RESOURCE_LIST] (state, action) {
    const index = state.secondResourceOverviewList.findIndex(({ id }) => {
      return id === action.item.id
    })
    if (index >= 0) {
      state.secondResourceOverviewList[index] = { ...state.secondResourceOverviewList[index], ...action.item }
    }
    state.secondResourceOverviewList = [].concat(state.secondResourceOverviewList)
  },
  [types.ADD_SECOND_RESOURCE_LIST_ITEM] (state, action) {
    state.secondResourceOverviewList = [].concat([action.item], state.secondResourceOverviewList)
  },
  [types.REMOVE_SECOND_RESOURCE_LIST_ITEM] (state, action) {
    const itemIndex = state.secondResourceOverviewList.findIndex(({id}) => {
      return id === action.item.id
    })
    if (itemIndex >= 0) {
      state.secondResourceOverviewList.splice(itemIndex, 1)
    }
  },
  [types.SET_TOTAL_NUMBER_OVERVIEW_LIST] (state, action) {
    state.totalNumberOverviewList = action.total
  },
  [types.UPDATE_RESOURCE_ITEM_IN_LIST] (state, action) {
    if (state.resourceOverviewList != null) {
      const itemIndex = state.resourceOverviewList.findIndex(({ id }) => action.id === id)
      if (itemIndex >= 0) {
        state.resourceOverviewList[itemIndex] = { ...state.resourceOverviewList[itemIndex], [action.key]: action.value }
        state.resourceOverviewList = [].concat(state.resourceOverviewList)
      }
    }
  },
  [types.UNSELECT_RESOURCE] (state) {
    state.selectedResource = null
  },
  [types.IS_FETCHING_LIST] (state, action) {
    state.isFetchingList = action.flag
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}
